export default "__VITE_ASSET__Bb8Sn2R5__"